import http from "../utils/request";
import type { ShopResponse } from "../types/shopMerchant";

export interface ShopStatisticsGroup {
  paidOrderCount: number;
  transactionAmount: number | string;
  refundOrderCount: number;
  refundAmount: number | string;
}

export interface ShopStatisticsData {
  selfOperated: ShopStatisticsGroup;
  merchant: ShopStatisticsGroup;
  selfSettlementAmount: number | string;
  selfPlatformCommissionAmount: number | string;
  merchantSettlementAmount: number | string;
  platformCommissionAmount: number | string;
  userRewardAmount: number | string;
}

export function getShopStatistics(
  startDate: string,
  endDate: string,
  signal?: AbortSignal
): Promise<ShopResponse<ShopStatisticsData>> {
  return http.get<never, ShopResponse<ShopStatisticsData>>(
    "/shop/merchant/shopStatistics",
    { params: { startDate, endDate }, signal }
  );
}
